import api from "./api";

export const getFinanceSummary = async () => {
  const { data } = await api.get("/admin/v1/finance/summary");
  return data;
};

export const listFinancePlans = async (query = {}) => {
  const { data } = await api.get("/admin/v1/finance/plans", { params: query });
  return data;
};

export const showFinancePlan = async (id) => {
  const { data } = await api.get(`/admin/v1/finance/plans/${id}`);
  return data;
};

export const listFinanceSubscriptions = async (query = {}) => {
  const { data } = await api.get("/admin/v1/finance/subscriptions", { params: query });
  return data;
};

export const showFinanceSubscription = async (id) => {
  const { data } = await api.get(`/admin/v1/finance/subscriptions/${id}`);
  return data;
};

export const listFinanceInvoices = async (query = {}) => {
  const { data } = await api.get("/admin/v1/finance/invoices", { params: query });
  return data;
};

export const showFinanceInvoice = async (id) => {
  const { data } = await api.get(`/admin/v1/finance/invoices/${id}`);
  return data;
};

export const listFinancePayments = async (query = {}) => {
  const { data } = await api.get("/admin/v1/finance/payments", { params: query });
  return data;
};

export const showFinancePayment = async (id) => {
  const { data } = await api.get(`/admin/v1/finance/payments/${id}`);
  return data;
};

export const listFinanceBillingEvents = async (query = {}) => {
  const { data } = await api.get("/admin/v1/finance/billing-events", { params: query });
  return data;
};

export const getCompanyFinance = async (id) => {
  const { data } = await api.get(`/admin/v1/finance/companies/${id}/finance`);
  return data;
};

export const getAsaasStatus = async () => {
  const { data } = await api.get("/admin/v1/finance/integrations/asaas/status");
  return data;
};

export const listAllCompanies = async () => {
  const { data } = await api.get("/admin/v1/announcements/companies");
  return data;
};
